import React from 'react';
import StartInterviewLayout from '../../components/layout/StartInterviewLayout';

const R = () => {
  return (
    <StartInterviewLayout type="r"/>
  )
}

export default R;